import { postUpdateOtherDetails } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKyc_UpdateOtherDetailsThunk = createAsyncThunk(
  "reKyc_UpdateOtherDetailsThunk",
  async ({ body, token }) => {
    try {
      const response = await postUpdateOtherDetails(body, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
